<template>
  <v-textarea
    v-model="form.info"
    rows="2"
    :counter="1500"
    :readonly="readonly"
    :error-messages="errors.info"
    :rules="getRulesByName('info')"
    @input="updateValue('info', $event)"
  />
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { maxLength, notEmoji } from '@/modules/_global/variables/rules';

export default {
  name: 'AdditionalInfoForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        info: ''
      },
      rules: {
        info: [maxLength(1500), notEmoji]
      }
    };
  }
};
</script>
